import ROUTES from '../../assets/routes'
import { AccountTabKey, AccountTabSlug, ACCOUNT_TAB_CONFIG } from './accountTabConfig'

const TAB_SLUGS: AccountTabSlug[] = ['personal', 'bank', 'nominee', 'demat', 'segments', 'funds', 'practice-trade']

const slugToKey = ACCOUNT_TAB_CONFIG.reduce<Record<AccountTabSlug, AccountTabKey>>((acc, tab) => {
    acc[tab.routeSlug] = tab.key
    return acc
}, {} as Record<AccountTabSlug, AccountTabKey>)

const keyToSlug = ACCOUNT_TAB_CONFIG.reduce<Record<AccountTabKey, AccountTabSlug>>((acc, tab) => {
    acc[tab.key] = tab.routeSlug
    return acc
}, {} as Record<AccountTabKey, AccountTabSlug>)

export const isAccountTabSlug = (slug: string): slug is AccountTabSlug =>
    TAB_SLUGS.includes(slug as AccountTabSlug)

export const accountTabKeyFromSlug = (slug: string): AccountTabKey | null =>
    isAccountTabSlug(slug) ? slugToKey[slug] : null

export const getAccountTabSlug = (key: AccountTabKey): AccountTabSlug =>
    keyToSlug[key]

export const getAccountTabPath = (key: AccountTabKey): string =>
    `${ROUTES.account}/${getAccountTabSlug(key)}`

export const isAccountRoute = (pathname: string): boolean =>
    pathname === ROUTES.account || pathname.startsWith(`${ROUTES.account}/`)
